import { cn } from '@cannect/lib/utils'
import { Typography } from '@cannect/new-components/atoms'
import { Images } from 'lucide-react'
import { ICategoryCard, ICategoryCardsProps } from './types'

export const CategoryCardsUI = ({
  categories,
  onCategoryClick,
  isSelectedCategory,
  className
}: ICategoryCardsProps) => {
  return (
    <section className={cn('mb-12', className)}>
      <div
        className={cn(
          'flex w-full gap-3 overflow-x-auto pb-2 md:grid md:overflow-x-visible',
          categories.length <= 5 ? 'md:grid-cols-5' : 'md:grid-cols-6'
        )}>
        {categories.map((category) => {
          const isSelected = isSelectedCategory(category)
          const hasLabel = !category.isViewAll && category.prescriptionLabel

          return (
            <div
              key={category.id}
              role="button"
              tabIndex={0}
              onClick={() => onCategoryClick(category)}
              onKeyDown={(e) => e.key === 'Enter' && onCategoryClick(category)}
              className={cn(
                'flex w-[140px] min-w-[140px] max-w-[140px] cursor-pointer flex-col overflow-hidden rounded-lg bg-white shadow-sm transition-all duration-200 hover:scale-[1.02] hover:shadow-md md:w-full md:min-w-0 md:max-w-none',
                isSelected && 'scale-[1.02] shadow-lg ring-1 ring-primary-500'
              )}>
              <div className="relative w-full bg-neutral-100 pt-[75%]">
                {category.image ? (
                  <img
                    src={category.image}
                    alt={category.title}
                    className="absolute inset-0 h-full w-full object-cover"
                  />
                ) : (
                  <div className="absolute inset-0 flex items-center justify-center">
                    <Images size={32} className="text-neutral-300" />
                  </div>
                )}
              </div>

              <div className="flex h-full flex-col gap-2 p-4 text-start">
                <Typography.Text weight="semibold" className="line-clamp-2 text-sm leading-tight text-neutral-800">
                  {category.title}
                </Typography.Text>

                <div className="flex-1" />

                {/* Badge sempre renderizado para manter altura uniforme */}
                <div
                  className={cn(
                    'inline-flex h-auto w-fit max-w-full items-center rounded-[2px] px-[8px] py-1 text-[9px] leading-[12px] text-neutral-600',
                    hasLabel
                      ? category.prescriptionLabel === 'Prescrição não necessária'
                        ? 'bg-primary-100'
                        : 'bg-tertiary-200'
                      : 'invisible'
                  )}>
                  {category.prescriptionLabel ?? 'placeholder'}
                </div>
              </div>
            </div>
          )
        })}
      </div>
    </section>
  )
}
